import { ComponentType } from "react";
import { Redirect, Route } from "react-router-dom";

type AuthProps = {
  exact?: boolean;
  path: string;
  component: ComponentType<any>;
}

export function AuthRoute({ component: Component, ...rest }: AuthProps) {
  const user = localStorage.getItem('user');

  return (
    <Route
      {...rest}
      render={props => {
        return user
          ? <Component {...props} />
          : <Redirect to="/" />
      }}>
    </Route>
  )
}